import { Component, Input, ElementRef, Renderer, ViewEncapsulation } from '@angular/core';
import { HostBinding, Host, Optional, forwardRef, Inject } from '@angular/core';
import classNames from 'classnames';

import { Menu } from './menu';
/**
 * Menu导航菜单
 * 参考: https://github.com/react-component/menu
 */
export class Divider {

    disabled = true;
/**
 * 用户CSS样式
 */
class: string;
/**
 * @param {?} renderer
 * @param {?} elementRef
 * @param {?} parentMenu
 */
constructor(
private renderer: Renderer,
private elementRef: ElementRef,
private parentMenu: Menu) {

    }
/**
 * 样式前缀
 * @return {?}
 */
get prefixCls(): string {
        return this.parentMenu && this.parentMenu.prefixCls || '';
    }
/**
 * 菜单样式
 * @return {?}
 */
get classes(): string {
        const /** @type {?} */ classes = classNames({
            [`${this.prefixCls}-item-divider`]: 1
        }, this.class);
        return classes;
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-divider',
    template: '<ng-content></ng-content>',
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
{type: Menu, decorators: [{ type: Inject, args: [forwardRef(() => Menu), ] }, { type: Optional }, { type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'class': [{ type: Input },],
'classes': [{ type: HostBinding, args: ['class', ] },],
};
}

function Divider_tsickle_Closure_declarations() {
/** @type {?} */
Divider.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Divider.ctorParameters;
/** @type {?} */
Divider.propDecorators;
/** @type {?} */
Divider.prototype.disabled;
/**
 * 用户CSS样式
 * @type {?}
 */
Divider.prototype.class;
/** @type {?} */
Divider.prototype.renderer;
/** @type {?} */
Divider.prototype.elementRef;
/** @type {?} */
Divider.prototype.parentMenu;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
